import React from "react";
import * as Yup from "yup";
import { isMobile } from "react-device-detect";
import { Divider, IconButton } from "@material-ui/core";
import { Facebook, LinkedIn, Close } from "@material-ui/icons";
import { Formik } from "formik";
import { DialogTitle } from "../Dialog.styles";
import { SignupMessage } from "../SignupMessage/SignupMessage";
import {
  StyledLabel,
  StyledDialogHeader,
  Footer,
  ErrorMessage,
} from "../SignIn/SignIn.styles";
import {
  DialogContainer,
  FlexWrapper,
  LoginWrapper,
  SocialLoginWrapper,
  SocialLogin,
  RulesMessage,
  StyledButton,
  DividerWrapper,
  StyledLink,
  DontHaveAccount,
} from "./SignUp.styles";
import { modalState } from "../../../redux/actions/modalAction";
import { signup } from "../../../redux/actions/authAction";
import { connect, useDispatch } from "react-redux";
import { Input, message } from "antd";
import { coreSignUpAPI } from "../../../api/Auth";
import { useAuthStore } from "../../../store/AuthStore";

const validationSchema = Yup.object().shape({
  // username: Yup.string().required("Username is required"),
  email: Yup.string().email().required("Email is required"),
  password1: Yup.string()
    .min(8, "Must Contain 8 Characters")
    .required("Password is required")
    .matches(/^(?=.*[a-z])/, " Must Contain One Lowercase Character")
    .matches(/^(?=.*[A-Z])/, "  Must Contain One Uppercase Character")
    .matches(/^(?=.*[0-9])/, "  Must Contain One Number Character")
    .matches(/^(?=.*[!@#$%^&*])/, "  Must Contain One Special Case Character"),
  password2: Yup.string()
    .required("Confirm Password is required")
    .oneOf([Yup.ref("password1"), null], "Passwords do not match"),
});

const SignUp = (props) => {
  const { open, setOpen, setSignUpState } = props;
  const { setIsVerified } = useAuthStore();
  const dispatch = useDispatch();
  const currentLocation = window.location.href;

  const initialValues = {
    email: "",
    password1: "",
    password2: "",
  };

  const redirectOutsite = (path) => {
    //eslint-disable-next-line
    location.href = path;
  };

  const socialIcons = [
    {
      icon: <Facebook />,
      label: "Facebook",
      hexColor: "#3b5998",
      url: `/oauth/login/facebook/?next=${currentLocation}`,
    },
    {
      icon: "G",
      label: "Google",
      hexColor: "#DE483C",
      url: `/oauth/login/google-oauth2/?next=${currentLocation}`,
    },
    {
      icon: <LinkedIn />,
      label: "LinkedIn",
      hexColor: "#0e76a8",
      url: `/oauth/login/google-oauth2/?next=${currentLocation}`,
    },
  ];

  const coreSignUp = async (values) =>
    coreSignUpAPI(values).then((res) => {
      if (res?.token) {
        if (!res.user.verified_account) {
          dispatch(modalState(false));
          setIsVerified(false);
          dispatch({
            type: "SET_VERIFIED",
            payload: false,
          });
          message.success("Please verify your email");
        }
      } else if (!res.status) {
        dispatch(modalState(false));
        message.error(res.email[0]);
      }
    });

  return (
    <DialogContainer
      fullScreen={isMobile}
      open={props.isOpen}
      onClose={() => props.modalState(false)}
      scroll="paper"
      aria-labelledby="form-dialog-title"
    >
      <Formik
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={(values) => {
          coreSignUp(values);
        }}
      >
        {({
          submitForm,
          status,
          values,
          handleSubmit,
          handleChange,
          errors,
          touched,
          handleBlur,
          setFieldValue,
        }) => (
          <FlexWrapper>
            <LoginWrapper>
              {isMobile ? (
                <StyledDialogHeader>
                  <DialogTitle>Signup With</DialogTitle>
                  <IconButton onClick={() => setOpen(false)}>
                    <Close />
                  </IconButton>
                </StyledDialogHeader>
              ) : (
                <h3>Signup With</h3>
              )}
              <SocialLoginWrapper>
                {socialIcons.map((each) => (
                  <SocialLogin
                    onClick={() => redirectOutsite(each.url)}
                    iconHex={each.hexColor}
                  >
                    {each.icon}
                  </SocialLogin>
                ))}
              </SocialLoginWrapper>
              <DividerWrapper>
                <span>OR</span>
                <Divider />
              </DividerWrapper>

              <StyledLabel>Email</StyledLabel>
              <Input
                name="email"
                type="email"
                placeholder="Email ID"
                onChange={handleChange}
                className="login-input"
                value={values.email}
                onBlur={handleBlur}
              />
              <ErrorMessage>
                {errors.email && touched.email && errors.email}
              </ErrorMessage>
              <StyledLabel>Password</StyledLabel>
              <Input.Password
                name="password1"
                type="password"
                placeholder="Password"
                onChange={handleChange}
                className="login-input"
                value={values.password1}
                onBlur={handleBlur}
              />
              <ErrorMessage>
                {errors.password1 && touched.password1 && errors.password1}
              </ErrorMessage>
              <StyledLabel>Password Confirmation</StyledLabel>
              <Input.Password
                name="password2"
                type="password"
                placeholder="Confirm Password"
                onChange={handleChange}
                className="login-input"
                value={values.password2}
                onBlur={handleBlur}
              />
              <ErrorMessage>
                {errors.password2 && touched.password2 && errors.password2}
              </ErrorMessage>
              <Footer>
                <RulesMessage>
                  By logging into DoveMed you agree to our {isMobile && <br />}
                  <StyledLink
                    onClick={() =>
                      redirectOutsite("/about-us/terms-conditions/")
                    }
                  >
                    {" "}
                    Terms of Use{" "}
                  </StyledLink>
                  and
                  <StyledLink
                    onClick={() => redirectOutsite("/privacy-policy/")}
                  >
                    {" "}
                    Privacy Policy
                  </StyledLink>
                </RulesMessage>
                <div>
                  <StyledButton
                    color="primary"
                    variant="contained"
                    onClick={submitForm}
                  >
                    Signup
                  </StyledButton>
                  {isMobile && (
                    <DontHaveAccount>
                      Have an account?{" "}
                      <span onClick={() => setSignUpState(false)}>SIGNIN</span>
                    </DontHaveAccount>
                  )}
                </div>
              </Footer>
            </LoginWrapper>
            {!isMobile && <SignupMessage setSignUpState={setSignUpState} />}
          </FlexWrapper>
        )}
      </Formik>
    </DialogContainer>
  );
};

const mapStateToProps = (state) => ({
  isOpen: state.modalReducer.isOpen,
});
export default connect(mapStateToProps, { modalState, signup })(SignUp);
